import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import GridAbout from "../components/gridAbout"
const AboutPage = () => (
  <Layout contentOverImage>
    <SEO title="About" />
    <div
      style={{
        margin: "2rem auto 1rem",
        maxWidth: "1000px",
        padding: "2rem 2rem",
        backgroundColor: "rgba(255,255,255,.9)",
        borderRadius: "5px",
        color: "white",
        fontStyle: "italic",
      }}
    >
      <GridAbout />
    </div>
  </Layout>
)

export default AboutPage
